import { Link } from "react-router-dom"
import { ACTIONS, API_URL, URLS } from "../../_config"
import { useCountries, useMenuList, useRole, useSelectedCountry, useUser } from "../../_common/hooks/authHook";
import { APP_NAME, LOGO_URL } from "../../_config/site_urls";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import React, { useEffect } from "react";
import { replaceUrlParams } from "../../_common/functions";

const Nav = () => {
    let userData: any = useUser();
    const userRole: any = useRole();
    const isMarketer = userRole === 'marketer';
    const dispatch = useDispatch();
    const countries: any = useCountries();
    const selectedCountry: any = useSelectedCountry();
    const location = useLocation();
    const currentRoute = location.pathname;
    const routeName = ["/business-plan/", "/addons/"].some(route => currentRoute.includes(route)) ? "country_disabled" : "Other";
    const [countryDisabled, setCountryDisabled] = React.useState(false);
    const menuList: any = useMenuList() || [];

    // console.log("menuList", menuList, selectedCountry);

    // useEffect(() => {
    //     if (!countries || countries.length === 0) return;

    //     // Avoid re-dispatching if selectedCountry is already set
    //     const matchedCountry = countries.find((country: any) =>
    //         country.country_name.toLowerCase().replace(/\s+/g, '-') === currentRoute.split('/')[1]
    //     );

        
    //     if (selectedCountry != matchedCountry.country_name.toLowerCase().replace(/\s+/g, '-')) {
            
    //         dispatch({
    //             type: ACTIONS.GEN_INFO.SELECTED_COUNTRY,
    //             payload: { selectedCountry: matchedCountry },
    //         });
    //     }


    // }, [currentRoute, countries, selectedCountry]);

    useEffect(() => {
        if (routeName === "country_disabled") {
            setCountryDisabled(true);
        } else {
            setCountryDisabled(false);
        }
    }, [routeName]);

    // const handleCountryChange = (selectedOption: any) => {
    //     console.log("Selected option:", selectedOption);
    //     dispatch({
    //       type: ACTIONS.GEN_INFO.SELECTED_COUNTRY,
    //       payload: { selectedCountry: selectedOption },
    //     });
    //   };

    return (
        <>
            <div className="navigation">
                <nav className="navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <Link className="navbar-brand p-0" to={URLS.HOME}> <img className="nav-logo" src={LOGO_URL} alt={APP_NAME} /></Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            {/* Customer nav items are hidden for marketers */}
                            {!isMarketer && <ul className="navbar-nav">

                                <li className="nav-item">
                                    <Link className="nav-link" to={URLS.CMS_PAGES.ABOUT_US}>About</Link>
                                </li>
                                {/* <li className="nav-item newDropdown">
                                    <a className="nav-link" href="#">Main Menu</a>
                                    <span className="downarrow"></span>
                                    <ul>
                                        <li>
                                            <a href="#">Consultation</a>
                                        </li>
                                        <li>
                                            <a href="#">Sub Menu 1</a>
                                            <span className="downarrow"></span>
                                            <ul>
                                                <li>
                                                    <a href="#">Dummy Page one</a>
                                                </li>
                                            </ul>
                                        </li> 
                                    </ul>
                                </li> */}
                                {
                                    menuList && menuList?.length > 0 && menuList.map((menu: any, index: number) => <>{
                                        (menu?.childs && menu?.childs?.length == 0 && menu?.pages && menu?.pages?.length == 0) ?
                                            <li key={`menu__${index}`} className="nav-item active">
                                                <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS, { pageSlug: menu?.slug })} className="nav-link">{menu?.cat_name} </Link>
                                            </li>
                                            :
                                            <li key={`menus__${menu?.cat_name}${index}`} className="nav-item newDropdown">
                                                <span className="nav-link dropdown-toggle" data-bs-toggle="dropdown"> {menu?.cat_name} </span>

                                                <ul className="dropdown-menu">
                                                    {
                                                        menu?.pages?.map((page: any, childIndex: number) =>
                                                            {page?.slug && <li key={`menu-page-${index}-${childIndex}`}>
                                                                {/* <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS, { pageSlug: page?.slug })} className="dropdown-item" > {page?.title} </Link> */}
                                                                <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_CAT, {country: selectedCountry.country_name.toLowerCase(),  catSlug: page?.slug })} className="dropdown-item" > {page?.title} </Link>
                                                            </li>}
                                                        )
                                                    }
                                                    {
                                                        menu?.childs?.map((child: any, childIndex: number) => <>
                                                            {
                                                                child?.childpages?.length > 0 && (
                                                                    <li key={`menu-childs-${index}-${childIndex}`}>
                                                                        <div className="dropdown-item" > {child?.cat_name} <span></span> </div>
                                                                        <ul className="submenu dropdown-menu">
                                                                            {
                                                                                child?.childpages?.filter((subChild: any) => subChild?.is_active === 1)?.map((subChild: any, subChildIndex: number) => <li key={`subChild-${index}-${childIndex}-${subChildIndex}`}>
                                                                                    <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_PAGE, {
                                                                                        country: selectedCountry.country_name.toLowerCase()?.replace(/\s+/g, '-'), catSlug: menu?.slug.toLowerCase(),
                                                                                        childCatSlug: child?.slug.toLowerCase(), pageSlug: subChild?.slug
                                                                                    })} className="dropdown-item">{subChild?.title}</Link>
                                                                                    {/* <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS, { pageSlug: subChild?.slug })} className="dropdown-item">{subChild?.title}</Link> */}
                                                                                </li>
                                                                                )
                                                                            }
                                                                        </ul>
                                                                    </li>
                                                                )
                                                                // (child?.childpages?.length == 0) ?
                                                                //     <li key={`menu-child-${index}-${childIndex}`}>
                                                                //         {/* <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS, { pageSlug: child?.slug })} className="dropdown-item" > {child?.cat_name} </Link> */}

                                                                //         <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_CHILD, {country: selectedCountry.country_name.toLowerCase()?.replace(/\s+/g, '-'),catSlug: menu?.slug.toLowerCase(),
                                                                //                         childCatSlug: child?.slug.toLowerCase() })} className="dropdown-item">{child?.cat_name}</Link>
                                                                //     </li>
                                                                //     :
                                                                //     <li key={`menu-childs-${index}-${childIndex}`}>
                                                                //         <div className="dropdown-item" > {child?.cat_name} <span></span> </div>
                                                                //         <ul className="submenu dropdown-menu">
                                                                //             {
                                                                //                 child?.childpages?.map((subChild: any, subChildIndex: number) => <li key={`subChild-${index}-${childIndex}-${subChildIndex}`}>
                                                                //                     <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS_DYNAMIC_PAGE, {country: selectedCountry.country_name.toLowerCase()?.replace(/\s+/g, '-'),catSlug: menu?.slug.toLowerCase(),
                                                                //                         childCatSlug: child?.slug.toLowerCase(), pageSlug: subChild?.slug })} className="dropdown-item">{subChild?.title}</Link>
                                                                //                     {/* <Link to={replaceUrlParams(URLS.MENU_PAGES.PAGE_DETAILS, { pageSlug: subChild?.slug })} className="dropdown-item">{subChild?.title}</Link> */}
                                                                //                 </li>
                                                                //                 )
                                                                //             }
                                                                //         </ul>
                                                                //     </li>
                                                            }
                                                        </>

                                                        )
                                                    }


                                                </ul>
                                            </li>
                                    }
                                    </>
                                    )
                                }

                                <li className="nav-item">
                                    <Link className="nav-link" to={URLS.BLOG_NEWS.LIST}>Blogs & News</Link>
                                </li>
                                {
                                    !userData && <li className="nav-item">
                                        <Link className="nav-link" to={URLS.CMS_PAGES.CONTACT_US}>Contact</Link>
                                    </li>
                                }
                            </ul>}
                            {!isMarketer && <div className="country-select ms-auto mx-4" style={{ width: "220px" }}>
                                <Select
                                    options={countries}
                                    onChange={(e) => {
                                        if (!e) return;
                                        dispatch({
                                            type: ACTIONS.GEN_INFO.SELECTED_COUNTRY, payload: { selectedCountry: e }
                                        });
                                    }}
                                    value={selectedCountry}
                                    isDisabled={countryDisabled}
                                    placeholder="Select a country"
                                />
                            </div>}
                            {
                                !userData ?
                                    <div className="login">
                                        <Link to={URLS.LOGIN}><i className='bx bx-lock-alt' ></i> Login</Link>
                                    </div>
                                    : isMarketer ?
                                        <div className="profile-dd dropdown ms-auto">
                                            <div className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <span><img src={userData?.avatar?.thumb} alt={`${userData?.first_name} ${userData?.last_name}`} /></span>    {userData?.first_name} {userData?.last_name}
                                            </div>
                                            <ul className="dropdown-menu">
                                                <li><Link className="dropdown-item" to={URLS.ACCOUNT.MY_ACCOUNT}><i className="bx bxs-user"></i> My Account</Link></li>
                                                <li><Link className="dropdown-item" to={URLS.MARKETER.CUSTOMERS}><i className="bx bxs-group"></i> Customers</Link></li>
                                                <li><Link className="dropdown-item" to={URLS.MARKETER.COMMISSION_HISTORY}><i className="bx bx-money"></i> Commission History</Link></li>
                                                <li><Link className="dropdown-item" to={URLS.LOGOUT}><i className="bx bx-log-out"></i> Sign Out</Link></li>
                                            </ul>
                                        </div>
                                        :
                                        <div className="profile-dd dropdown">
                                            <div className="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                                <span><img src={userData?.avatar?.thumb} alt={`${userData?.first_name} ${userData?.last_name}`} /></span>    {userData?.first_name} {userData?.last_name}
                                            </div>
                                            <ul className="dropdown-menu">
                                                <li><Link className="dropdown-item" to={URLS.ACCOUNT.MY_ACCOUNT}><i className="bx bxs-user"></i> My Account</Link></li>
                                                <li><Link className="dropdown-item" to={URLS.ACCOUNT.MY_BUSINESS_PLAN}><i className="bx bxs-business"></i> My Business Plan</Link></li>
                                                <li><Link className="dropdown-item" to={URLS.ACCOUNT.TICKET.LIST}><i className="bx bxs-book-content"></i> My Tickets</Link></li>
                                                <li><Link className="dropdown-item" to={URLS.LOGOUT}><i className="bx bx-log-out"></i> Sign Out</Link></li>
                                            </ul>
                                        </div>
                            }
                        </div>
                    </div>
                </nav>
            </div>
        </>
    )
}

export default Nav